/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowbrandcolorsnone4Inputs */

const en_aiflowbrandcolorsnone4 = /** @type {(inputs: Aiflowbrandcolorsnone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No brand colours yet:`)
};

const de_aiflowbrandcolorsnone4 = /** @type {(inputs: Aiflowbrandcolorsnone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Markenfarben:`)
};

/**
* | output |
* | --- |
* | "No brand colours yet:" |
*
* @param {Aiflowbrandcolorsnone4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowbrandcolorsnone4 = /** @type {((inputs?: Aiflowbrandcolorsnone4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowbrandcolorsnone4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowbrandcolorsnone4(inputs)
	return de_aiflowbrandcolorsnone4(inputs)
});
export { aiflowbrandcolorsnone4 as "aiFlowBrandColorsNone" }